import { Paper, Stack, Group, Badge, Table, Text } from "@mantine/core"
import { useHover } from "@mantine/hooks"
import { IconPencil } from "@tabler/icons-react"

import { returnRegexMatches } from "@costory/front/pages/VirtualDimensions/components/AutoSplit/utils"

interface SummaryProps {
  mappingType: string
  datasource?: string
  mapping: Record<string, string>
  onClick: () => void
  regexValue?: string
  selectedDatasourceMetrics: { name: string }[]
}
export const Summary = ({
  mappingType,
  datasource,
  mapping,
  onClick,
  regexValue,
  selectedDatasourceMetrics,
}: SummaryProps) => {
  const regexMatches = returnRegexMatches(
    regexValue ?? "",
    selectedDatasourceMetrics,
    false,
  )
  const { hovered, ref } = useHover()
  return (
    <Paper
      p="md"
      onClick={onClick}
      style={{ cursor: "pointer" }}
      shadow="md"
      radius="md"
      ref={ref}
    >
      <Stack>
        <Group justify="space-between">
          <>
            <Text fw={700} size="lg">
              Configuration {"    "}
              {hovered && <IconPencil size={16} stroke={1.5} />}
            </Text>
          </>
          <Badge style={{ cursor: "pointer" }}>{mappingType}</Badge>
        </Group>
        {datasource && (
          <Group gap="xs">
            <Text fw={500} size="sm">
              Usage Metric:
            </Text>
            <Text size="sm" c="dimmed">
              {datasource}
            </Text>
          </Group>
        )}
        {mappingType === "mapping" && Object.keys(mapping).length > 0 && (
          <>
            <Text fw={500} size="sm">
              Mapping:
            </Text>
            <Table>
              <Table.Thead>
                <Table.Tr>
                  <Table.Th>Metric Dimension</Table.Th>
                  <Table.Th>Virtual Dimension Value</Table.Th>
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                {Object.entries(mapping)
                  .filter(([_, value]) => value !== "")
                  .map(([key, value]) => (
                    <Table.Tr key={key}>
                      <Table.Td>{key}</Table.Td>
                      <Table.Td>{value}</Table.Td>
                    </Table.Tr>
                  ))}
              </Table.Tbody>
            </Table>
          </>
        )}
        {mappingType === "regexMapping" && regexValue && (
          <>
            <Group gap="xs">
              <Text fw={500} size="sm">
                Regex:
              </Text>
              <Text size="sm" c="dimmed">
                {regexValue}
              </Text>
            </Group>
            <Group gap="xs">
              <Text fw={500} size="sm">
                Example Outputs:
              </Text>
              <Text size="sm" c="dimmed">
                {regexMatches.slice(0, 3).join(", ")}
              </Text>
            </Group>
          </>
        )}
      </Stack>
    </Paper>
  )
}
